import { tableData } from "../../../utils/tableData";

//this function returns input type data
export const getConfigDataByName = (name) => {
  
  let item;
  tableData.forEach((d) => {
    if (d.subs) {
      d.subs.forEach((it) => {
        if (it.input.textAreas) {
          it.input.textAreas.forEach((ta) => {
            if (ta.name == name) {
              item = it;
            }
          });
        } else if (it.input.name == name) item = it;
      });
    } else {
      if (d.input.name == name) item = d;
    }
  });
  return item;
};
